<div class="layout-footer">
    <div class="footer-logo-container">
        <!-- <img id="footer-logo" src="assets/layout/images/logo-dark.svg" alt="diamond-layout"/> -->
        <!-- <span class="app-name">ONCORE</span> -->
    </div>
    <span class="copyright">&#169; onCore - {{currentYear}}</span>
</div>
